import ToBooleanText from '../../components/utilities/Table/helperKIvaTable';
import { RequestWarranty } from '../../components/utilities/Table/generalColumns/RequestWarranty';

const commonColumns = [
    RequestWarranty,
    ToBooleanText('tramite', 'Tramite voluntario', 'tramite_voluntario'),
    {
        Header: 'Identificación',
        accessor: 'solicitud.persona.numero_identificacion',
    },
    {
        Header: 'Cliente',
        accessor: 'solicitud.persona.full_name',
        typeId: 'HeaderClient',
    },
    {
        Header: 'Nro crédito',
        accessor: 'credito.num_credito',
    },
    {
        Header: 'Producto',
        accessor: 'credito.subproducto.label',
    },
    {
        Header: 'Placa',
        accessor: 'solicitud.vehiculossolicitud.placa_vehiculo',
    },
    {
        Header: 'Estado',
        accessor: 'estado.label',
    },
];

const requestsWarrantyList = [
    {
        id: 'bolsa_general',
        label: 'BOLSA GENERAL',
        responsable: false,
        status: '7',
        offices: true,
        columns: commonColumns,
        registrationLimit: 5,
        buttonAction: [{ name: 'takeRequestWarranty' }],
    },
    {
        id: 'proceso',
        label: 'EN PROCESO',
        offices: true,
        responsable: true,
        status: '7',
        columns: commonColumns,
        registrationLimit: 5,
    },
    {
        id: 'procesadas',
        label: 'PROCESADAS',
        responsable: false,
        columns: commonColumns,
        registrationLimit: 5,
        nameColumnProcessed: [
            {
                name: 'usuario_liquidacion',
                value: 'user',
                operator: '%26',
            },
        ],
    },
];
export default requestsWarrantyList;
